export default "__VITE_ASSET__aa25191d__"